export const soDigitos = (s: string) => s.replace(/\D/g, '');

export function cpfValido(raw: string) {
  const c = soDigitos(raw);
  if (c.length !== 11 || /^(\d)\1{10}$/.test(c)) return false;
  const dv = (len: number) => {
    let s = 0;
    for (let i = 0; i < len; i++) s += Number(c[i]) * (len + 1 - i);
    const r = (s * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dv(9) === Number(c[9]) && dv(10) === Number(c[10]);
}

export function mascaraCpf(raw: string) {
  const c = soDigitos(raw).slice(0, 11);
  return c.replace(/^(\d{3})(\d)/, '$1.$2').replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3').replace(/\.(\d{3})(\d{1,2})$/, '.$1-$2');
}

/**
 * O login é pelo CPF. Por trás, o CPF vira um endereço interno único na caixa myplanner.mestre@gmail.com
 * (nenhum e-mail é enviado a ele, porque a confirmação de e-mail fica desligada). O e-mail real da pessoa fica no perfil (email_contato).
 * Antes do lançamento, isso vira uma busca no servidor que encontra a conta pelo CPF.
 */
export const emailDoCpf = (cpf: string) => `myplanner.mestre+${soDigitos(cpf)}@gmail.com`;
export const cpfDoEmail = (email?: string | null) => email?.match(/\+(\d{11})@/)?.[1] ?? null;

/** Login pelo CPF (Brasil) ou pelo e-mail (qualquer país). */
export const loginDe = (id: string) => (id.includes('@') ? id.trim().toLowerCase() : emailDoCpf(id));
